import type { DictationTextFieldOptions } from '@features/dictation/components/DictationTextField';

/**
 * Product vocabulary the recognizer should spell exactly when someone dictates a
 * support message. Fixed strings only: never user or patient data.
 */
export const SUPPORT_DICTATION_KEYTERMS = [
  'JotPsych',
  'Jot',
  'JotBill',
  'JotAudit',
  'JotRx',
  'JotMeet',
  'DoseSpot',
  'Stedi',
  'Intake Hub',
  'eligibility',
  'clearinghouse',
  'prior authorization',
  'superbill',
  'CPT code',
  'ICD-10',
  'progress note',
  'SOAP note',
  'treatment plan',
  'telehealth',
  'Chrome extension',
  'EHR',
];

export const SUPPORT_DICTATION: DictationTextFieldOptions = {
  surface: 'jot_support',
  keyterms: SUPPORT_DICTATION_KEYTERMS,
  prompt:
    'A clinician describes a problem or question about the JotPsych charting and billing application to the support team.',
};
